import {
  BlotterDensity,
  BlotterTable,
  createInputFocusGridInnerElementHandler,
  type DateOnly,
  useBlotterTable,
  type useMultiMarketDataSnapshot,
} from '@talos/kyoko';
import type { Fixing } from './fixingSlice';
import { fixingInputID, useFixingBlotterColumns } from './useFixingBlotterColumns';
import { type FixingBlotterRow, useFixingBlotterDataObs } from './useFixingBlotterDataObs';

interface FixingBlotterProps {
  fixings: Fixing[];
  onFixingChange: (fixingIndex: string, fixingPrice: string) => void;
  multiMarketDataObs: ReturnType<typeof useMultiMarketDataSnapshot>;
  fixingDate: DateOnly | undefined;
}

export const FixingBlotter = ({ fixings, multiMarketDataObs, onFixingChange, fixingDate }: FixingBlotterProps) => {
  const dataObservable = useFixingBlotterDataObs(fixings, multiMarketDataObs, fixingDate);
  const columns = useFixingBlotterColumns({ onFixingChange });

  const blotterTable = useBlotterTable<FixingBlotterRow>({
    dataObservable,
    errorObservable: undefined,
    rowID: 'rowID' satisfies keyof FixingBlotterRow,
    density: BlotterDensity.Comfortable,
    applyTransactionsSynchronously: true,
    gridOptions: {
      // Keep AG Grid row containers out of the tab order so Tab moves between inline inputs.
      tabIndex: -1,
      suppressHeaderFocus: true,
      focusGridInnerElement: createInputFocusGridInnerElementHandler({
        getTopInputID: fixingInputID,
      }),
    },
    columns,
  });

  return <BlotterTable {...blotterTable} />;
};
